export default __webpack_public_path__ + "static/media/Screenshot_8.9c67a486.png";